import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { CandidacyAgenticScoreChange, HttpResponse } from "@/types";

export function useOverrideAgenticScore() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({
      candidacyId,
      toScore,
      justification,
    }: {
      candidacyId: string;
      toScore: number;
      justification: string;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/override-agentic-rating`;
      const res = await guacHttpClient.post<
        CandidacyAgenticScoreChange,
        HttpResponse<CandidacyAgenticScoreChange>
      >(path, { justification, toScore });

      return res.data;
    },
  });

  return mutation;
}
